<div class="h-100 cart-preview-page-container">
  <app-past-due-banner />
  <div class="offcanvas-header">
    <h3>Your added products</h3>
  </div>
  <div class="cart-preview__checkout animated fadeInDown">
    <button class="btn btn-secondary btn-sm d-block w-100" [routerLink]="['/order']">
      Go to Checkout
    </button>
  </div>


  <hr class="m-0 animated fadeInRight border-0 border-bottom">

  <span class="h7-bold text-center">
    Subtotal: {{subTotal().toFixed(2) | currency}}
  </span>

  @if (totalSavings()) {
  <p class="h7-bold text-primary d-flex gap-1 align-content-center justify-content-center m-0">
    <span>
      Savings:
    </span>
    <span>
      {{totalSavings() | currency}}
    </span>
  </p>
  }

  <hr class="m-0 animated fadeInRight border-0 border-bottom">

  <!-- See Available Promotions (DEV-9447) -->
  <div class="py-2">
    <app-available-promotions-button [compact]="true"></app-available-promotions-button>
  </div>

  @if(notYetSavedProducts()) {
  <div class="p-0 d-flex justify-content-start animated fadeInDown">
    <small class="cart-preview__label">Not Yet Saved</small>
  </div>
  <!-- Firebase "subscription" products -->
  @for (product of notYetSavedProducts()?.subscription; track product.variantId + '_' + (product.package?.id || '')) {
  <app-product-cart-preview [product]="product" [allowModification]="!isExplorerUser()"
    [allowRemoval]="!isExplorerUser()" productKey="subscription"></app-product-cart-preview>
  }
  <!-- Firebase "a la carte" products -->
  @for (product of notYetSavedProducts()?.common; track product.variantId + '_' + (product.package?.id || '')) {
  <app-product-cart-preview [product]="product" productKey="common"></app-product-cart-preview>
  }
  }

  @if (inYourOrderProducts()) {
  @if (notYetSavedProducts()) {
  <hr>
  }

  <div class="p-0 d-flex flex-column gap-1 justify-content-start animated fadeInDown">
    <small class="cart-preview__label">
      In Your Order
    </small>
  </div>
  <!-- Odoo "subscription" products -->
  <!-- Saved lines keep their quantity read-only, but can be taken out of the order (DEV-10936). -->
  @for (product of inYourOrderProducts()?.subscription; track product.variantId + '_' + (product.package?.id || '')) {
  <app-product-cart-preview [allowModification]="false" [allowRemoval]="true" [product]="product"
    productKey="subscription"></app-product-cart-preview>
  }
  <!-- Odoo "a la carte" products -->
  @for (product of inYourOrderProducts()?.common; track product.variantId + '_' + (product.package?.id || '')) {
  <app-product-cart-preview [allowModification]="false" [allowRemoval]="true" [product]="product"
    productKey="subscription"></app-product-cart-preview>
  }
  }

  @if (carouselFavoritesProducts()?.length) {
  <div class="product-highlight">
    <h3 class="product-highlight__title">Your favorites</h3>
    <div class="product-highlight__body">
      <app-carousel [items]="carouselFavoritesProducts()"></app-carousel>
    </div>
  </div>
  }
  @if (carouselBuyAgainProducts()?.length) {
  <div class="product-highlight">
    <h3 class="product-highlight__title">Buy again</h3>
    <div class="product-highlight__body">
      <app-carousel [items]="carouselBuyAgainProducts()"></app-carousel>
    </div>
  </div>
  }
  @if (carouselSuggestedProducts()?.length) {
  <div class="product-highlight">
    <h3 class="product-highlight__title">Other people also added</h3>
    <div class="product-highlight__body">
      <app-carousel [items]="carouselSuggestedProducts()"></app-carousel>
    </div>
  </div>
  }
</div>